import { destroySafe, Type } from '@deqo/foundation';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { EditorSession } from '../../canvas/EditorSession';
import { WidgetManager } from '../../canvas/workspace/widgets/WidgetManager';
import { Activator, ActiveObject, resolve } from '../../Container';
import { Lens } from './Lens';
import { LensInfo } from './LensInfo';
import { LensTypes } from './LensTypes';

export class LensMechanics extends ActiveObject {

    @resolve(Activator) private activator!: Activator;
    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(EditorSession) private session!: EditorSession;
    @resolve(WidgetManager) private widgets!: WidgetManager;

    private activeLens = null as Lens;

    public start(): void {
        this.burden(
            this.session.observe(LensInfo, this.realizeActiveLens),
            () => destroySafe(this.activeLens)
        );
    }

    private realizeActiveLens = (next: LensInfo) => {

        destroySafe(this.activeLens);
        this.activeLens = null;

        const type = LensTypes.for(next.type);
        if (!type) return null;

        const inst = this.activeLens = this.activator.call(type as Type<Lens>);
        inst.configure(next.filter);
        inst.start();
    };
}
